/** @format */

import React, { useState } from "react"
import { Button } from "@ui-library/core"
import { Body, StyledPopin } from "./RemiseStockPopin.styled";
import { LoadingCircle } from "_components/atoms/QuickRepartitionProgressBar/QuickRepartitionProgressBar.styled";
import bffClient from "_clients/BFFClient";
import { RemiseStockPopinProps } from "./RemiseStockPopin.types";
import { displayToast } from "_stores/toast";
import { useAvailableBoostStore } from "_stores/availableBoost/availableBoost";
import { Distribution, useDistributionStore } from "_stores/distribution/distribution";

const RemiseStockPopin = (props: RemiseStockPopinProps) => {
    const MAX_PAGE_SIZE = 999999;
    const { onClosePopin, open, newAvailableStock, searchParams } = props;
    const { upsertAvailableBoost } = useAvailableBoostStore();
    const { upsertDistributions } = useDistributionStore();
    const [isLoading, setIsLoading] = useState(false);
    
    const getDistributions = async () => {
        const response = searchParams.networkId 
            ? await bffClient.getNetworkMemberDistribution(
                searchParams.networkId, 
                searchParams.productType, 
                searchParams.marketId,
                searchParams.searchTerm, 
                MAX_PAGE_SIZE, 
                searchParams.pageNumber,
                null, 
                [],
                null
            )
            : await bffClient.getMultiBeneficiariesMemberDistribution(
                Number(searchParams.contractId),
                searchParams.productType,
                searchParams.marketId,
                searchParams.searchTerm,
                MAX_PAGE_SIZE,
                searchParams.pageNumber,
                null,
                [],
                null
            )
        return response.result.members;
    }

    const stashAllCreditsAsync = async () => {
        try {
            setIsLoading(true);
            searchParams.networkId 
                ? await bffClient.stashAllCredits(searchParams.networkId, searchParams.productType, searchParams.marketId, null)
                : await bffClient.stashAllMultiBeneficiariesCredits(searchParams.contractId, searchParams.productType, searchParams.marketId, null);
           
            const distributionsFromBackend = await getDistributions();
            const enabledDistributions = distributionsFromBackend.filter(m => m.isEnabled);
            const distributionsForStore : Distribution[] = enabledDistributions.map(m => ({
                networkId: searchParams.networkId,
                contractId: searchParams.contractId ? Number(searchParams.contractId) : undefined,
                rcuId: m.rcuID,
                marketId: searchParams.marketId,
                productType: searchParams.productType,
                addDate: new Date(),
                selectionModeType: m.selectionModeType,
                newAllocatedBoosts: m.consumedBoosts ?? 0
            }));
            
            upsertDistributions(distributionsForStore);

            upsertAvailableBoost({
                networkId: searchParams.networkId,
                contractId: searchParams.contractId,
                marketId: Number(searchParams.marketId),
                productType: searchParams.productType,
                newTotalAvailableBoosts: newAvailableStock,
                newDistributedNotUsedBoosts: 0,
                addDate: new Date(),
            });

            onClosePopin();
            displayToast({
                headerText: "Félicitations !",
                message: "Vous avez réussi à réinitialiser votre partage et à remettre en stock tous les boosts inutilisés de votre membre.",
                type: "success",
            });
        } catch (error) {
            console.log(error);
        }
        finally {
            setIsLoading(false);
        }
    }

	return (
		<StyledPopin
			open={open}
			size="small"
			onClose={onClosePopin}
            testID="gsl.uilib.remiseStock.Popin"
		>
			{
				<Body data-testid="gsl.uilib.buyMoreResponse.confirm.Popin">
					<p className="title">
                        Confirmez-vous le rappel des crédits distribués et non utilisés ?
                    </p>
                    <p className="text-wrapper">
                        {"Certains boosts distribués n'ont pas été utilisés par vos membres. Vous pouvez réinitialiser votre répartition pour remettre tous vos boosts non utilisés en stock."}
                    </p>
                    <Button
                        disabled={isLoading}
                        size="medium"
                        testID="btn-confirm-remise-stock"
                        kind="primary"
                        variant="normal"
                        tag="button"
                        onClick={() => stashAllCreditsAsync()}
                        onPointerEnterCapture={undefined}
                        onPointerLeaveCapture={undefined}
				    >
					    {isLoading ? <LoadingCircle/> : "Confirmer"}
				    </Button>
				</Body>
			}
		</StyledPopin>
	)
}

export default RemiseStockPopin
